<template>
  <hr/>
  <div class="columns is-multiline is-centered ">
    <div class="column spaced-left is-12-tablet is-6-desktop">
      <h4 class="has-text-centered">{{ $t("profile.OSRBirdStatus.osrHfTabSection.local.header", { }) }} </h4>
      <single-osr-chart :dataType="'under'" v-if="data" />
      <figure>
        <div v-html='$t("profile.OSRBirdStatus.osrHfTabSection.local.figure", { sppName: state?.sppName })'/>
      </figure>
    </div>
    <div class="column spaced-right is-12-tablet is-6-desktop">
      <h4 class="has-text-centered">{{ $t("profile.OSRBirdStatus.osrHfTabSection.regional.header",  { sppName: state?.sppName }) }} </h4>
      <single-osr-chart :dataType="'total'" v-if="data"/>
      <figure>
        <div v-html='$t("profile.OSRBirdStatus.osrHfTabSection.regional.figure",  {  sppName: state?.sppName })'/>
      </figure>

    </div>
  </div>
</template>

<script>
/*
  density estimation charts show them side by side
    WebOSIndustrialFacilitiesLocal:
    WebOSIndustrialFacilitiesRegional

    use key to draw component
*/

import { useApp } from '@/composables/state/profileState';
import { useI18n } from 'vue-i18n';
import SingleOSRSectorEffectBarChart from './SingleOSRSectorEffectBarChart.vue';
export default {
  name: 'osr-sector-effect-chart-layout',
  components: { 'single-osr-chart': SingleOSRSectorEffectBarChart },
  props: ['data'],
  setup (props) {
    // const { tm } = useI18n();
    const { state, sppContent } = useApp();

    return {
      state,
      sppContent,
    }
  }
}
</script>
